// src/data/projectContent.js

const legalProject = [
  {
    title: "Aspectos Legales en la Tokenización de Activos",
    value: `
##  Introducción

Este proyecto está diseñado para guiarte en la integración correcta de documentos legales dentro del proceso de tokenización de activos en blockchain.

Antes de codificar un contrato inteligente, es esencial que el documento legal que representa el activo esté debidamente redactado, firmado y registrado en el mundo real. Este paso ayuda a evitar problemas legales posteriores.

---

##  Lineamientos Legales en México

1. **El activo debe estar registrado y ser legalmente transferible**.
2. **El contrato debe estipular la naturaleza del token** (fungible o no fungible).
3. **Se debe cumplir con la Ley para Regular las Instituciones de Tecnología Financiera (Ley Fintech)**.
4. En caso de representar valores (acciones, deuda), se deben atender las disposiciones de la **Comisión Nacional Bancaria y de Valores (CNBV)**.

---

##  Contrato Legal Base (ejemplo redactado)

\`\`\`plaintext
CONTRATO DE REPRESENTACIÓN DIGITAL Y TOKENIZACIÓN DE ACTIVO

En la ciudad de [Ciudad], a los [Día] días del mes de [Mes] del año [Año], comparecen:

[Nombre del Cedente], mayor de edad, con domicilio en [Domicilio completo], en adelante “El Cedente”.

Y [Nombre de la Plataforma o Empresa Tokenizadora], representada por [Nombre del Representante], en adelante “La Plataforma”.

CLÁUSULAS:

1. El Cedente declara ser propietario legítimo del activo descrito en el Anexo I.
2. La Plataforma se compromete a representar dicho activo mediante un token digital sobre la red [Ethereum/Polygon/Solana].
3. El presente contrato no implica transmisión de propiedad sino representación simbólica.
4. En caso de conflicto, las partes se someten a los tribunales de [Ciudad].

Anexo I:
Tipo de activo: Inmueble
Ubicación: Calle Ficticia 123
Valor estimado: $2,500,000 MXN

Anexo II:
Nombre del Token: CasaTokenMX
Tipo: ERC721
Hash del documento: \\[HASH SHA-256 DEL PDF\\]
\`\`\`

---

##  Ejemplo de Llenado

- Ciudad: Ciudad de México  
- Cedente: Juan Pérez  
- Plataforma: TokenizaMX S.A.P.I. de C.V.  
- Red: Polygon  
- Token: ERC721  
- Hash: 0xaabf13ef45...

---

##  Ley Fintech Mexicana (Resumen Cláusulas Relevantes)

- **Artículo 3**: Define los activos virtuales y su tratamiento legal.  
- **Artículo 30**: Las Instituciones de Tecnología Financiera deben establecer mecanismos de verificación y validación de identidad.  
- **Artículo 44**: Las ITF que operen con activos virtuales deberán contar con autorización de la CNBV y aplicar medidas de prevención de lavado de dinero.

 Referencia oficial: [https://www.diputados.gob.mx/LeyesBiblio/pdf/LRITF.pdf](https://www.diputados.gob.mx/LeyesBiblio/pdf/LRITF.pdf)

---

##  Recomendaciones Técnicas

- Subir el contrato firmado a [IPFS](https://ipfs.tech/)  
- Insertar el hash en el contrato inteligente (\`contractHash\`)  
- Establecer límites de transferencia si representa propiedad compartida  
- Proteger el contrato con control de acceso (\`Ownable\` o \`AccessControl\` en Solidity)

---

##  Resultado Esperado

Un contrato legal claro, firmado digital o físicamente, vinculado a un token en blockchain mediante hash. Este documento será la base para evitar conflictos y probar la legitimidad del token ante terceros.
    `,
  },
];

export default legalProject;
